module.exports = __webpack_public_path__ + "static/media/techno.0a26bb97.gif";